import React from 'react';
import PropTypes from "prop-types";

import {Col, FormGroup, Input, Label} from 'reactstrap';
import DatePicker from "react-datepicker";
import {FormattedMessage} from "react-intl";
import SelectFormGroup from "components/NonFormsyForm/SelectFormGroup";

class Filter extends React.Component {
    static propTypes = {
        dateFrom: PropTypes.object.isRequired,
        dateTo: PropTypes.object.isRequired,
        searchTerm: PropTypes.string,
        ad: PropTypes.number,
        availableAds: PropTypes.array.isRequired,
        onChangeDateFrom: PropTypes.func.isRequired,
        onChangeDateTo: PropTypes.func.isRequired,
        onChangeSearchTerm: PropTypes.func.isRequired,
        onChangeSearchOnlyAd: PropTypes.func.isRequired,
    };

    render() {
        const {dateFrom, dateTo, searchTerm, ad, availableAds, onChangeDateFrom, onChangeDateTo, onChangeSearchTerm, onChangeSearchOnlyAd} = this.props;

        return (
            <div className="controls">
                <div className="search">
                    <div className="search__form">
                        <FormGroup>
                            <Input type="text" onChange={onChangeSearchTerm} value={searchTerm}/>
                        </FormGroup>
                    </div>
                    <h5><FormattedMessage id="catalogue.time_interval" defaultMessage="Časový interval"/></h5>
                    <FormGroup className="form-row mb-2">
                        <Label for="from" className="col-sm-2 col-form-label"><FormattedMessage id="catalogue.from" defaultMessage="From"/>:</Label>
                        <Col sm={8}>
                            <DatePicker className="form-control datepicker react-datepicker-ignore-onclickoutside" dateFormat="LL" id="from"
                                        onChange={onChangeDateFrom} selected={dateFrom}/>
                        </Col>
                    </FormGroup>
                    <FormGroup className="form-row mb-2">
                        <Label for="to" className="col-sm-2 col-form-label"><FormattedMessage id="catalogue.to" defaultMessage="To"/>:</Label>
                        <Col sm={8}>
                            <DatePicker className="form-control datepicker" dateFormat="LL" id="to"
                                        onChange={onChangeDateTo} selected={dateTo}/>
                        </Col>
                    </FormGroup>
                    <h5><FormattedMessage id="catalogue.ad" defaultMessage="Ad"/></h5>
                    <SelectFormGroup id="operatorAds" name="operatorAds" values={availableAds} setValue={onChangeSearchOnlyAd} valueSelected={ad} />
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/containers/Catalogue/Filter/index.jsx